import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { ChevronLeft } from 'lucide-react';

import { useGoBack } from '@muzly/shared';

/**
 * 드릴다운 화면의 상단 바(시안 `top bar`) — 좌 `<` · 가운데 제목(16px Medium) · 우 부속.
 * 이력·결과 상세·더보기 하위 화면이 같은 바를 쓴다. 제목이 가운데라 좌우 폭을 맞춰야
 * 하므로 부속이 없어도 오른쪽 자리는 비워 둔다.
 */
export const PageHeader = ({
  title,
  right,
  onBack,
}: {
  title: ReactNode;
  right?: ReactNode;
  /** 없으면 히스토리 뒤로가기. */
  onBack?: () => void;
}) => {
  const { t } = useTranslation();
  const goBack = useGoBack();
  return (
    <header className="relative flex h-14 items-center justify-between px-2">
      <button
        type="button"
        onClick={() => (onBack ? onBack() : void goBack())}
        aria-label={t('web.common.back')}
        className="flex h-11 w-11 items-center justify-center text-bk-900"
      >
        <ChevronLeft className="h-6 w-6" strokeWidth={2} />
      </button>
      <h1 className="pointer-events-none absolute inset-x-14 truncate text-center text-base font-medium tracking-[-0.16px] text-bk-900">
        {title}
      </h1>
      <div className="flex h-11 min-w-11 items-center justify-center">
        {right}
      </div>
    </header>
  );
};
